

export class CalorieDeficitCalculation {
    constructor (weight, weeks) {
        this.weight = weight
        this.weeks = weeks
    }

    get weightPerWeek () {
        return this.weight / this.weeks
    }

    get calorieDeficitPerDay () {
        return this.weightPerWeek * 1000
    }

    get recommended () {
        return (this.weight/0.5) === this.weeks
    }

}